
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}><MDXTag name="h1" components={components} props={{"id":"프로젝트-요구사항"}}>{`프로젝트 요구사항`}</MDXTag>
<MDXTag name="p" components={components}><MDXTag name="inlineCode" components={components} parentName="p">{`@devsisters/ui-*`}</MDXTag>{`를 사용하기 위해서는 프로젝트에 다음의 설정이 되어있어야 합니다.`}</MDXTag>
<MDXTag name="ul" components={components}>
<MDXTag name="li" components={components} parentName="ul">{`필수사항`}<MDXTag name="ul" components={components} parentName="li">
<MDXTag name="li" components={components} parentName="ul"><MDXTag name="a" components={components} parentName="li" props={{"href":"https://webpack.js.org/"}}>{`webpack 4`}</MDXTag>{` 이상`}<MDXTag name="ul" components={components} parentName="li">
<MDXTag name="li" components={components} parentName="ul"><MDXTag name="inlineCode" components={components} parentName="li">{`*.module.css`}</MDXTag>{`: `}<MDXTag name="a" components={components} parentName="li" props={{"href":"https://github.com/webpack-contrib/css-loader"}}>{`css loader`}</MDXTag></MDXTag>
<MDXTag name="li" components={components} parentName="ul"><MDXTag name="inlineCode" components={components} parentName="li">{`*.png`}</MDXTag>{`: `}<MDXTag name="a" components={components} parentName="li" props={{"href":"https://github.com/webpack-contrib/file-loader"}}>{`file loader`}</MDXTag>{` 또는 `}<MDXTag name="a" components={components} parentName="li" props={{"href":"https://github.com/webpack-contrib/url-loader"}}>{`url loader`}</MDXTag></MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`다음의 프레임웍 중 하나를 사용중이라면 위 설정이 이미 되어있습니다.`}<MDXTag name="ul" components={components} parentName="li">
<MDXTag name="li" components={components} parentName="ul"><MDXTag name="a" components={components} parentName="li" props={{"href":"https://github.com/facebook/create-react-app"}}>{`Create React App 2.x`}</MDXTag></MDXTag>
<MDXTag name="li" components={components} parentName="ul"><MDXTag name="a" components={components} parentName="li" props={{"href":"https://www.gatsbyjs.org/"}}>{`GatsbyJS v2`}</MDXTag></MDXTag>
</MDXTag></MDXTag>
</MDXTag></MDXTag>
</MDXTag></MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`권장사항`}<MDXTag name="ul" components={components} parentName="li">
<MDXTag name="li" components={components} parentName="ul"><MDXTag name="a" components={components} parentName="li" props={{"href":"https://www.typescriptlang.org/"}}>{`TypeScript`}</MDXTag>{`를 사용하세요.`}<MDXTag name="ul" components={components} parentName="li">
<MDXTag name="li" components={components} parentName="ul"><MDXTag name="inlineCode" components={components} parentName="li">{`@devsisters/ui-*`}</MDXTag>{`의 모든 컴포넌트는 타입정보를 제공합니다.`}</MDXTag>
</MDXTag></MDXTag>
<MDXTag name="li" components={components} parentName="ul"><MDXTag name="inlineCode" components={components} parentName="li">{`.module.css`}</MDXTag>{` 파일 확장자에 `}<MDXTag name="a" components={components} parentName="li" props={{"href":"https://github.com/webpack-contrib/css-loader#modules"}}>{`css modules 설정`}</MDXTag>{`을 해주세요.`}</MDXTag>
</MDXTag></MDXTag>
</MDXTag>
           </MDXTag>
  }
}
  